document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('floating-atc');
  var atcContainer = document.querySelector('.add-to-cart-container');
  if (!bar || !atcContainer) return;

  var observer = new IntersectionObserver(function (entries) {
    var visible = entries[0].isIntersecting;
    bar.classList.toggle('is-visible', !visible);
    bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
  }, { threshold: 0 });

  observer.observe(atcContainer);

  bar.querySelector('[data-floating-atc-btn]').addEventListener('click', function () {
    var target = atcContainer.closest('.section-product') || atcContainer;
    var top = target.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
});
